import { Configuration, ErrorResponse } from "../api";
import { OnFail, OnSuccess } from "../core";

export const IsSuccessStatusCode = (statusCode: number): boolean => {
    return statusCode >= 200 && statusCode <= 299;
}

export const Execute = <T>(configuration: Configuration, onSuccess: OnSuccess<T>, onFail: OnFail): void => {
    fetch(configuration.url, { method: configuration.method })
    .then(async (response: Response) => {
        if (!IsSuccessStatusCode(response.status)) {
            if (response.body !== null) {
                const resp = await response.json() as ErrorResponse;
                onFail({ type: resp.type });
            } else {
                onFail({ type: "unknown" });
            }

            return;
        }

        if (response.body !== null) {
            const resp = await response.json() as T;
            onSuccess(resp);
        } else {
            onFail({ type: "empty body" });
        }
    })
    .catch((error: ErrorResponse) => {
        onFail(error);
    });
}
